<template>
  <div>
    <p
      v-for="(line, lineNumber) of text.split('{break}')"
      v-bind:key="lineNumber"
    >
      <span v-html="replaceLink(line)"></span><br />
    </p>
  </div>
</template>

<script>
export default {
  props: ["text", "link"],
  methods: {
    replaceLink(line) {
      return line.replace(
        "{link}",
        "<a href='" +
          this.link.url +
          "' target='_blank'>" +
          this.link.text +
          "</a>"
      );
    },
  },
};
</script>
